import { render } from "./BotPositionsList.vue?vue&type=template&id=5c2f77c8&scoped=true"
import script from "./BotPositionsList.vue?vue&type=script&lang=js"
export * from "./BotPositionsList.vue?vue&type=script&lang=js"

import "./BotPositionsList.vue?vue&type=style&index=0&id=5c2f77c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2f77c8"]])

export default __exports__